import React from "react";
import StatusBanner from "./StatusBanner";

const formatList = (items = []) =>
	items.length ? items.map((m) => `.${m}`).join(", ") : "—";

/**
 * Shows backend-sourced bulk import prep limits.
 */
const ImportLimitsNotice = ({
	limits,
	variant = "full",
	className = "",
}) => {
	if (!limits) return null;

	const {
		max_items: maxItems,
		max_active_per_publisher: maxActive,
		max_cover_mb: maxCoverMb,
		max_pdf_mb: maxPdfMb,
		max_manifest_mb: maxManifestMb,
		cover_mimes: coverMimes,
		pdf_mimes: pdfMimes,
		manifest_mimes: manifestMimes,
	} = limits;

	if (variant === "list") {
		return (
			<StatusBanner
				tone="info"
				title="Book list limits"
				className={className}
			>
				<ul className="list-disc space-y-1 pl-4 text-sm">
					<li>
						Up to <strong>{maxItems}</strong> data rows per import
					</li>
					<li>
						File size up to <strong>{maxManifestMb} MB</strong> (
						{formatList(manifestMimes)})
					</li>
				</ul>
			</StatusBanner>
		);
	}

	if (variant === "files") {
		return (
			<StatusBanner tone="info" title="File size limits" className={className}>
				<ul className="list-disc space-y-1 pl-4 text-sm">
					<li>
						Covers: up to <strong>{maxCoverMb} MB</strong> (
						{formatList(coverMimes)})
					</li>
					<li>
						PDFs: up to <strong>{maxPdfMb} MB</strong> (
						{formatList(pdfMimes)})
					</li>
				</ul>
			</StatusBanner>
		);
	}

	return (
		<StatusBanner
			tone="info"
			title="Prepare your upload within these limits"
			className={className}
		>
			<ul className="list-disc space-y-1 pl-4 text-sm">
				<li>
					At most <strong>{maxActive}</strong> active imports at a time
				</li>
				<li>
					Up to <strong>{maxItems}</strong> books (rows) per book list
				</li>
				<li>
					Book list file up to <strong>{maxManifestMb} MB</strong> (
					{formatList(manifestMimes)})
				</li>
				<li>
					Cover images up to <strong>{maxCoverMb} MB</strong> each (
					{formatList(coverMimes)})
				</li>
				<li>
					PDFs up to <strong>{maxPdfMb} MB</strong> each (
					{formatList(pdfMimes)})
				</li>
			</ul>
		</StatusBanner>
	);
};

export default ImportLimitsNotice;
